import React from "react";
import "./Footer.css";
import FooterTop from "./FooterTop";
import fab from "../../../images/Social/facebook.png";
import inst from "../../../images/Social/inst.png";
import youtube from "../../../images/Social/youtube.png";
import tiktok from "../../../images/Social/tiktok.png";

const Footer = () => {
  return (
    <div className="footer_bg pb-2">
      <FooterTop />
      <div className="pb-2">
        <div className="container">
          <div className="row mx-auto w-100 row-reverse">
            <div className="col-5 col-md-3 padding-top px-0">
              <p className="footer_title">Support</p>
              <div className="support pt-1">
                <h6 className="text-secondary">FAQs</h6>
                <h6 className="text-secondary">Cancellation Options</h6>
                <h6 className="text-secondary">Report concern</h6>
              </div>
            </div>
            <div className="col-7 col-md-3 padding-top px-0">
              {" "}
              <p className="footer_title">Community</p>
              <div className="community pt-1">
                <h6 className="text-secondary">We Share - Tel Aviv</h6>
                <h6 className="text-secondary">We Share - Ramla</h6>
                <h6 className="text-secondary">We Share - Safed</h6>
                <h6 className="text-secondary">We Share - Dubai</h6>
                <h6 className="text-secondary ">We Share - Tel Aviv</h6>
                <h6 className="text-secondary">We Share - Abu Dhabi</h6>
              </div>
            </div>
            <div className="col-5 col-md-3 padding-top px-0">
              <p className="footer_title">Hosting</p>
              <div className="hosting pt-1">
                <h6 className="text-secondary ">Try hosting</h6>
                <h6 className="text-secondary">
                  We Share Insurance: <br /> Protection for Hosts
                </h6>
                <h6 className="text-secondary ">Explore hosting resources</h6>
                <h6 className="text-secondary ">How to host responsibly</h6>
              </div>
            </div>
            <div className="col-7 col-md-3 padding-top px-0">
              <p className="footer_title">About</p>
              <div className="about pt-1">
                <h6 className="text-secondary">Privacy</h6>
                <h6 className="text-secondary">Terms of Service</h6>
                <h6 className="text-secondary">Investors</h6>
              </div>
              <div className="footer_icon">
                <img src={fab} alt="" />
                <img src={inst} alt="" />
                <img src={youtube} alt="" />
                <img src={tiktok} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
